module.exports = __webpack_public_path__ + "img/weddings_14_V.5b1faf3d.webp";